import { render, staticRenderFns } from "./SolutionCounter.vue?vue&type=template&id=6f8b2360"
import script from "./SolutionCounter.vue?vue&type=script&lang=js"
export * from "./SolutionCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports